<template>
  <main
    class="container"
    v-infinite-scroll="fetchCases"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="20"
  >
    <transition name="slide">
      <a
        v-if="bulkDelete.length > 0"
        href="#"
        @click.prevent="deleteMultiple"
        class="bulk-delete"
      >
        <svg width="52pt" height="52pt" viewBox="0 0 52 52">
          <path
            d="M 23 -0.0625 C 19.085938 -0.0625 15.9375 3.1875 15.9375 7.125 L 15.9375 8 L 8 8 C 6.898438 8 6 8.898438 6 10 L 6 12 L 4 12 L 4 16 L 8 16 L 8 46 C 8 49.289063 10.710938 52 14 52 L 38 52 C 41.289063 52 44 49.289063 44 46 L 44 16 L 48 16 L 48 12 L 46 12 L 46 10 C 46 8.898438 45.101563 8 44 8 L 36.0625 8 L 36.0625 7.125 C 36.0625 3.1875 32.914063 -0.0625 29 -0.0625 Z M 23 4.0625 L 29 4.0625 C 30.609375 4.0625 31.9375 5.375 31.9375 7.125 L 31.9375 8 L 20.0625 8 L 20.0625 7.125 C 20.0625 5.375 21.390625 4.0625 23 4.0625 Z M 12 16 L 22.25 16 C 22.5 16.023438 22.742188 16.0625 23 16.0625 L 29 16.0625 C 29.257813 16.0625 29.5 16.023438 29.75 16 L 40 16 L 40 46 C 40 47.125 39.125 48 38 48 L 14 48 C 12.875 48 12 47.125 12 46 Z M 16 20 L 16 44 L 20 44 L 20 20 Z M 24 20 L 24 44 L 28 44 L 28 20 Z M 32 20 L 32 44 L 36 44 L 36 20 Z "
          />
        </svg>
        Bulk Delete
      </a>
      <div v-else class="empty-space"></div>
    </transition>

    <transition name="slide">
      <transition-group
        name="update-images"
        tag="section"
        v-if="caseStudies.length > 0"
        id="caseStudies-grid"
        class="mt-4"
      >
        <CaseStudyEditCard
          v-for="caseStudy in caseStudies"
          :caseStudy="caseStudy"
          :marked="bulkDelete.includes(caseStudy)"
          :key="caseStudy.id"
          @addToBulkDelete="toggleBulkDelete(caseStudy)"
          @deleteCard="deleteCard(caseStudy)"
          @updateName="updateNameInDatabase"
        />
      </transition-group>
      <section v-else>
        <div class="row page-title">
          <div class="col-12">
            <h3>It's lonely here</h3>
            <p>Why don't you upload some caseStudies</p>
          </div>
        </div>
      </section>
    </transition>

    <a
      v-if="bulkDelete.length > 1 && caseStudies.length > 20"
      href="#"
      class="bulk-delete mb-4 mb-xl-5"
    >
      <svg width="52pt" height="52pt" viewBox="0 0 52 52">
        <path
          d="M 23 -0.0625 C 19.085938 -0.0625 15.9375 3.1875 15.9375 7.125 L 15.9375 8 L 8 8 C 6.898438 8 6 8.898438 6 10 L 6 12 L 4 12 L 4 16 L 8 16 L 8 46 C 8 49.289063 10.710938 52 14 52 L 38 52 C 41.289063 52 44 49.289063 44 46 L 44 16 L 48 16 L 48 12 L 46 12 L 46 10 C 46 8.898438 45.101563 8 44 8 L 36.0625 8 L 36.0625 7.125 C 36.0625 3.1875 32.914063 -0.0625 29 -0.0625 Z M 23 4.0625 L 29 4.0625 C 30.609375 4.0625 31.9375 5.375 31.9375 7.125 L 31.9375 8 L 20.0625 8 L 20.0625 7.125 C 20.0625 5.375 21.390625 4.0625 23 4.0625 Z M 12 16 L 22.25 16 C 22.5 16.023438 22.742188 16.0625 23 16.0625 L 29 16.0625 C 29.257813 16.0625 29.5 16.023438 29.75 16 L 40 16 L 40 46 C 40 47.125 39.125 48 38 48 L 14 48 C 12.875 48 12 47.125 12 46 Z M 16 20 L 16 44 L 20 44 L 20 20 Z M 24 20 L 24 44 L 28 44 L 28 20 Z M 32 20 L 32 44 L 36 44 L 36 20 Z "
        />
      </svg>
      Bulk Delete
    </a>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../main";
import { caseStudyCollection } from "../firebase-config";
import infiniteScroll from "vue-infinite-scroll";
import CaseStudyEditCard from "@/components/CaseStudyEditCard";

export default {
  data() {
    return {
      bulkDelete: []
    };
  },
  components: {
    CaseStudyEditCard
  },
  computed: {
    ...mapGetters({ caseStudies: "caseStudies/caseStudies" })
  },
  methods: {
    async deleteCard(caseStudy) {
      const x = confirm("Are you sure you want to delete " + caseStudy.name);
      if (x) {
        try {
          await caseStudyCollection.doc(caseStudy.id).delete();
          alert(`${caseStudy.name} successfully deleted`);
        } catch (err) {
          console.error(err);
        }
      }
    },
    async deleteMultiple() {
      if (this.bulkDelete.length > 0) {
        for (let caseStudy of this.bulkDelete) {
          try {
            await caseStudyCollection.doc(caseStudy.id).delete();
            console.log(`${caseStudy.name} Successfully deleted`);
          } catch (err) {
            console.error(err);
          }
        }
        alert(this.bulkDelete.length + " images successfully deleted");
        this.bulkDelete = [];
      }
    },
    toggleBulkDelete(caseStudy) {
      const caseStudyIndex = this.bulkDelete.findIndex(
        page => page.id === caseStudy.id
      );
      if (caseStudyIndex >= 0) {
        return this.bulkDelete.splice(caseStudyIndex, 1);
      }
      this.bulkDelete.push(caseStudy);
    },

    async updateNameInDatabase(updatedcaseStudy) {
      if (updatedcaseStudy)
        try {
          caseStudyCollection.doc(updatedcaseStudy.id).update({
            name: updatedcaseStudy.name,
            image: updatedcaseStudy.image
          });
          alert("saved");
        } catch (err) {
          console.error(err);
        }
    },
    ...mapActions({ fetchCases: "caseStudies/fetchCases" })
  },
  directives: { infiniteScroll },
  mounted() {
    EventBus.$emit(
      "allLinks",
      document.querySelectorAll(".mark-delete, .edit, .image-wrapper, input")
    );
  }
};
</script>

<style lang="scss" scoped>
.bulk-delete {
  display: inline-block;
  height: 15px;
  svg {
    margin-right: 10px;
    fill: white;
    width: 15px;
  }
  &:hover {
    color: brown;

    svg {
      fill: brown;
    }
  }
}

.empty-space {
  display: block;
  height: 40px;
}

#caseStudies-grid {
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 2rem;
}

.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
  position: absolute;
}

.slide-enter-active,
.slide-leave-active {
  transition: 0.3s all ease;
}

.slide-enter-active {
  transition-delay: 0.3s;
}

.update-images-enter,
.update-images-leave-to {
  transform: scale(0);
}

.update-images-enter-active,
.update-images-leave-active {
  transform: scale(1);
}
</style>
